module.exports = __webpack_public_path__ + "static/img/zj002.0b2a31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/zj002.png
// module id = n2eh
// module chunks = 1